import { render, staticRenderFns } from "./lp.vue?vue&type=template&id=1c810d9b&"
import script from "./lp.vue?vue&type=script&lang=ts&"
export * from "./lp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports